import { render } from "./MyPlannedEntries.vue?vue&type=template&id=65ddaf34"
import script from "./MyPlannedEntries.vue?vue&type=script&lang=js"
export * from "./MyPlannedEntries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__